export const ADMIN = 'admin';
export const GESTOR = 'gestor';
export const COLABORADOR = 'colaborador';

export const ROLES = [
  ADMIN,
  GESTOR,
  COLABORADOR,
];
